import { render, staticRenderFns } from "./ReportPlayerDetailed.vue?vue&type=template&id=c08f6090"
import script from "./ReportPlayerDetailed.vue?vue&type=script&lang=js"
export * from "./ReportPlayerDetailed.vue?vue&type=script&lang=js"
import style0 from "./ReportPlayerDetailed.vue?vue&type=style&index=0&id=c08f6090&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports